/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import _ from "lodash";
import {__} from "language";
import {decodeEntities as decodeAllEntities} from "security";
import {passThroughIfLoggedIn} from "authentication";
import {simpleRequest} from "ajax";
import {AE_BID_TYPES} from "@auex/configurations";

export function cancelLot(params, callback) {
  const ajaxData = {
    auctionId: params.auctionId,
    lotId: params.lotId,
    orgId: params.organizationId,
  };

  simpleRequest({
    data: ajaxData,
    endPoint: "lot/cancel",
  }, callback);
}

export function createLot(params, callback) {
  const ajaxData = {
    orgId: params.organizationId,
    auctionId: params.auctionId,
    lotStartingBid: params.lotStartingBid,
    itemName: params.itemName,
    itemDescription: params.itemDescription,
    itemDetails: params.itemDetails,
    itemPictures: params.itemPictures,
    underApproval: params.underApproval,
  };

  simpleRequest({
    endPoint: "lot/create",
    data: ajaxData,
  }, callback);
}

export function updateLotInfo(params, callback) {
  const ajaxData = {
    orgId: params.organizationId,
    auctionId: params.auctionId,
    lotId: params.lotId,
    lotStartingBid: params.lotStartingBid,
    itemName: params.itemName,
    itemDescription: params.itemDescription,
    itemDetails: params.itemDetails,
    itemPictures: params.itemPictures,
    underApproval: params.underApproval,
  };

  simpleRequest({
    endPoint: "lot/info",
    data: ajaxData,
  }, callback);
}

export function makeBid(params, callback) {
  passThroughIfLoggedIn(
    __("auction::lot.logInToBid"),
    AuctionEx.csrfToken,
    () => {
      const ajaxData = {
        auctionId: params.auctionId,
        lotId: params.lotId,
        bidType: params.bidType,
        bidAmount: params.bidAmount,
      };

      simpleRequest({
        endPoint: "lot/bid",
        data: ajaxData,
      }, callback);
    },
  );
}

export function makeStandardBid(params, callback) {
  makeBid(
    _.merge({}, params, {bidType: AE_BID_TYPES.STANDARD}),
    callback,
  );
}

export function makeMaximumBid(params, callback) {
  makeBid(
    _.merge({}, params, {bidType: AE_BID_TYPES.MAXIMUM}),
    callback,
  );
}

export function watch(params, callback) {
  const ajaxData = {
    lotId: params.lotId,
  };

  simpleRequest({
    endPoint: "lot/watch",
    data: ajaxData,
  }, callback);
}

export function unwatch(params, callback) {
  const ajaxData = {
    lotId: params.lotId,
  };

  simpleRequest({
    endPoint: "lot/unwatch",
    data: ajaxData,
  }, callback);
}

export function decodeEntities(lot) {
  lot.name = decodeAllEntities(lot.name);
  lot.description = lot.description && decodeAllEntities(lot.description);

  return lot;
}



// WEBPACK FOOTER //
// ../lot.js